import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-page">
            <section className="policy-content-section">
                <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '3rem 1.5rem' }}>
                    <h1 style={{
                        color: '#069668',
                        fontSize: '2.5rem',
                        marginBottom: '5rem',
                        textAlign: 'center'
                    }}>Privacy Policy</h1>
                    <div className="policy-last-updated" style={{ marginBottom: '2rem', color: '#666' }}>
                        <p><strong>Last Updated:</strong> January 3, 2026</p>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>1. Introduction</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            At Yathartha, we are committed to protecting your privacy and ensuring the security of your personal information.
                            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services.
                        </p>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>2. Information We Collect</h2>
                        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '1rem' }}>
                            We collect information that you provide directly to us, including:
                        </p>
                        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '2rem' }}>
                            <li>Personal identification information (name, email address, phone number)</li>
                            <li>Financial information for diagnosis and planning purposes</li>
                            <li>Communication preferences and feedback</li>
                            <li>Usage data and analytics when you interact with our website</li>
                        </ul>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>3. How We Use Your Information</h2>
                        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '1rem' }}>
                            We use the information we collect to:
                        </p>
                        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '2rem' }}>
                            <li>Provide, maintain, and improve our financial advisory services</li>
                            <li>Create personalized financial diagnoses and roadmaps</li>
                            <li>Communicate with you about our services and updates</li>
                            <li>Ensure the security and integrity of our services</li>
                            <li>Comply with legal obligations</li>
                        </ul>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>4. Information Sharing and Disclosure</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
                        </p>
                        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '2rem' }}>
                            <li>With your explicit consent</li>
                            <li>To comply with legal obligations or respond to lawful requests</li>
                            <li>To protect our rights, privacy, safety, or property</li>
                            <li>With trusted service providers who assist in our operations (under strict confidentiality agreements)</li>
                        </ul>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>5. Data Security</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access,
                            alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure, and we cannot
                            guarantee absolute security.
                        </p>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>6. Your Rights</h2>
                        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '1rem' }}>
                            You have the right to:
                        </p>
                        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '2rem' }}>
                            <li>Access and receive a copy of your personal information</li>
                            <li>Request correction of inaccurate or incomplete information</li>
                            <li>Request deletion of your personal information</li>
                            <li>Opt-out of marketing communications</li>
                            <li>Withdraw consent at any time</li>
                        </ul>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>7. Cookies and Tracking Technologies</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            We use cookies and similar tracking technologies to enhance your experience on our website, analyze usage patterns,
                            and deliver personalized content. You can control cookie settings through your browser preferences.
                        </p>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>8. Changes to This Privacy Policy</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy
                            on this page and updating the "Last Updated" date.
                        </p>
                    </div>

                    <div className="policy-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>9. Contact Us</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            If you have any questions about this Privacy Policy or our privacy practices, please contact us at:
                        </p>
                        <p style={{ lineHeight: '1.8', color: '#333', marginTop: '1rem' }}>
                            <strong>Email:</strong> privacy@yathartha.com<br />
                            <strong>Phone:</strong> +91 1234567890
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PrivacyPolicy;
